import React, { useEffect, useState } from "react";
import { Offcanvas, Form, Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useForm, Controller, useWatch } from "react-hook-form";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashCan } from "@fortawesome/free-solid-svg-icons";
import {
  AllParameter,
  allVerificationType,
} from "../../../../../../../features/admin/common/Slice";
import Select from "react-select";
import Common_Back_Btn from "../../../../../../../common/common_components/common_back_btn/Common_Back_Btn";
import Gray_Btn from "../../../../../../../common/common_btn/gray_btn/Gray_Btn";
import Black_Submit_Btn from "../../../../../../../common/common_btn/black_submit_btn/Black_Submit_Btn";
import Refresh_btn from "../../../../../../../common/common_btn/refresh_btn/Refresh_btn";
import Success_Toster from "../../../../../../../common/common_modal/success_toster/Success_Toster";
import {
  GetSingle,
  GetAll,
  Update,
} from "../../../../../../../features/admin/quality_management/process_requirement/quality_control/Slice";
import { formatDateForInput } from "../../../../../../../utils/common";
import { useFieldArray } from "react-hook-form";

function Quality_Plan_Edit_Offcanvas({ show, handleClose, id }) {
  const dispatch = useDispatch();
  const [removedFiles, setRemovedFiles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [showError, setShowError] = useState(null);

  const [companiesPreview, setCompaniesPreview] = useState(null);
  const [attachPreview, setAttachPreview] = useState(null);

  const all_parameter = useSelector((state) => state.common.all_parameter);

  const all_verification_type = useSelector(
    (state) => state.common.all_verification_type,
  );

  const {
    register,
    handleSubmit,
    reset,
    setValue,
    trigger,
    control,
    getValues,
    watch,
    formState: { errors },
  } = useForm();

  const { fields, append, remove, replace } = useFieldArray({
    control,
    name: "observations",
  });

  useEffect(() => {
    dispatch(AllParameter());
    dispatch(allVerificationType());
  }, [dispatch]);

  /* ---------------- GET SINGLE ---------------- */
  const GetData = async (id) => {
    try {
      setLoading(true);
      const res = await dispatch(GetSingle(id));

      if (res.meta?.requestStatus === "fulfilled") {
        const data = res.payload.data;

        //map ID → label
        const verifyType = all_verification_type?.find(
          (o) => o.value === data.type_of_verification_id,
        )?.label;

        const observationsData =
          data.Selection_Type_Record_Observations?.map((o) => ({
            value: o.observation_value,
          })) || [];

        const apiParams =
          data.Quality_Parameters || data.quality_parameters || [];

        const mappedParameters = all_parameter.map((param) => {
          const existing = apiParams.find(
            (p) => Number(p.parameter_id) === Number(param.value),
          );

          return {
            parameter_id: param.value,
            value: existing?.value || "",
          };
        });

        reset({
          type_of_verification_id: data.type_of_verification_id || null,
          frequency: data.frequency || "",
          remark: data.remark || "",
          parameters: mappedParameters,
        });
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (show && id && all_parameter?.length && all_verification_type?.length) {
      GetData(id);
    }
  }, [show, id, all_parameter, all_verification_type]);

  /* ---------------- SUBMIT ---------------- */
  const onSubmit = async (data) => {
    try {
      const sendData = {
        type_of_verification_id: data.type_of_verification_id,
        frequency: data.frequency,
        remark: data.remark,
        parameters: data.parameters.filter((p) => p.value),
      };

      const res = await dispatch(Update({ id, sendData }));

      if (res.meta?.requestStatus === "fulfilled") {
        setSuccess(true);
        dispatch(GetAll());
        setTimeout(() => {
          setSuccess(false);
          handleClose();
        }, 1500);
      } else {
        setShowError(res.payload?.response?.data?.errors);
      }
    } catch (error) {
      console.error(error);
    }
  };

  /* ---------------- AUTO HIDE SUCCESS ---------------- */
  useEffect(() => {
    if (success) {
      const timer = setTimeout(() => setSuccess(false), 3000);
      return () => clearTimeout(timer);
    }
  }, [success]);

  const handleRemoveCompanies = () => {
    setCompaniesPreview(null);
    setValue("degree", null);
    setRemovedFiles((prev) =>
      prev.includes("degree") ? prev : [...prev, "degree"],
    );
  };

  const handleRemoveAttach = () => {
    setAttachPreview(null);
    setValue("training_certificate", null);
    setRemovedFiles((prev) =>
      prev.includes("training_certificate")
        ? prev
        : [...prev, "training_certificate"],
    );
  };

  return (
    <Offcanvas
      className="mobile_offcanvas Imperiality_view_offcanvas common_offcanvas"
      show={show}
      placement="end"
      onHide={handleClose}
    >
      <Offcanvas.Header>
        <Offcanvas.Title>
          <div className="back_div" onClick={handleClose}>
            <Common_Back_Btn />
          </div>
          Edit Quality Control Plan
        </Offcanvas.Title>
      </Offcanvas.Header>

      <Offcanvas.Body>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <div className="white_container customer_section">
            <div className="row">
              <div className="col-md-6">
                <Form.Group className="form_group">
                  <Form.Label>Type Of Verification</Form.Label>
                  <Controller
                    name="type_of_verification_id"
                    control={control}
                    defaultValue={null}
                    rules={{ required: "Type of Verification is required" }}
                    render={({ field }) => (
                      <Select
                        options={all_verification_type}
                        value={
                          all_verification_type?.find(
                            (o) => o.value === field.value,
                          ) || null
                        }
                        onChange={(e) => field.onChange(e?.value || null)}
                      />
                    )}
                  />
                  {errors.type_of_verification_id && (
                    <span className="text-danger">
                      {errors.type_of_verification_id.message}
                    </span>
                  )}
                </Form.Group>
              </div>

              <div className="col-md-6">
                <Form.Group className="form_group">
                  <Form.Label>Remark</Form.Label>
                  <Form.Control
                    {...register("remark", {
                      required: "remark is required",
                    })}
                  />
                  {errors.remark && (
                    <span className="text-danger">{errors.remark.message}</span>
                  )}
                </Form.Group>
              </div>

              <div className="col-md-6">
                <Form.Group className="form_group">
                  <Form.Label>Frequency</Form.Label>
                  <Form.Control
                    {...register("frequency", {
                      required: "Frequency is required",
                    })}
                  />
                  {errors.frequency && (
                    <span className="text-danger">
                      {errors.frequency.message}
                    </span>
                  )}
                </Form.Group>
              </div>

              {/* ===== ACCEPTANCE PARAMETER CRITERIA ===== */}
              <div className="row mt-3">
                <div className="col-md-12">
                  <Form.Label>Acceptance Parameter Criteria</Form.Label>
                </div>

                {all_parameter?.map((item, index) => (
                  <div className="col-md-3" key={item.value}>
                    <Form.Control
                      placeholder={item.label}
                      {...register(`parameters.${index}.value`)}
                    />

                    <input
                      type="hidden"
                      value={item.value}
                      {...register(`parameters.${index}.parameter_id`)}
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className="offcanvas_footer_holder">
            {success ? (
              <Success_Toster successText="Updated Successfully!" />
            ) : (
              <>
                <div className="btns_holder">
                  <Gray_Btn btnText="Cancel" onClick={handleClose} />
                  <Black_Submit_Btn btnText="Submit" type="submit" />
                </div>
                {/* <Refresh_btn /> */}
              </>
            )}
          </div>
        </Form>
      </Offcanvas.Body>
    </Offcanvas>
  );
}

export default Quality_Plan_Edit_Offcanvas;
